module.exports = __webpack_public_path__ + "static/media/image66.1e1b1f37.jpg";